module.exports = "/images/preloader.svg?c49febc48585999dcaf4dc35de4b4b12";